import {
  LayeredVisualisation,
  ViewController,
  createTree,
  createLayeredTree
} from 'sagevis';
import {
  json
} from 'd3-request';


function visualize(threadContent) {
  // Visualization
  var layeredVis = document.querySelector("#visualisation");

  while (layeredVis.firstChild) {
    layeredVis.removeChild(layeredVis.firstChild);
  }

  let type = threadContent.type,
    threadData = threadContent.data,
    number_of_clusters = threadContent.numClusters || null;


  let tree_set = [];

  if (type == "trace") {
    for (let i = 0; i < threadData.length; i++) {
      let treeModel = createTree(threadData[i]),
        root = treeModel.getRoot();
      root.up();

      tree_set.push(treeModel);
    }
  } else {
    let treeModel = createLayeredTree(threadData);
    tree_set.push(treeModel);
  }

  let controller = new ViewController();

  controller.addView(new LayeredVisualisation("#visualisation"));
  controller.setData(tree_set, number_of_clusters);
  controller.updateViews();

  // Create a callback for when a window resizes.
  window.onresize = function() {
    controller.resize();
  }
}


function makeOptionList(id, array) {
  var list = document.getElementById(id);

  list.addEventListener('change', function() {
    loadData("data/" + this.value);
  });

  for (var i = 0; i < array.length; i++) {
    var item = document.createElement('option');

    item.appendChild(document.createTextNode(array[i]));
    list.appendChild(item);
  }

  console.log(list);
  return list;
}

/**
 * Main javascript function for this program. It initializes the
 */
function init() {
  json('data/file_list.json', function(jsonFile) {
    let list;

    if (jsonFile.length != null){
      loadData("data/" + jsonFile[0]);
      try {
        list = makeOptionList('t-selector', jsonFile);
        document.getElementById('trace-selector').appendChild(list);
      }
      catch (e) {
        console.log("Trace selector is not found...")
      }
    }
    else {
      throw "Error!! list of traces is empty... :("
    }
  });
}



function loadData(fileName) {
  json(fileName, function(jsonFile) {
    visualize(jsonFile);
  });
}


window.onload = init();
